import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { Invite, IPagination } from './@types';
import AuthServices from './auth.api';
import { getAuthToken } from '../utils/getAuthToken';

class InviteService {
  private api: AxiosInstance;

  constructor(baseURL: string) {
    this.api = axios.create({
      baseURL,
      headers: { 'Content-Type': 'application/json' },
    });

    this.api.interceptors.request.use((config) => {
      const token = getAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          AuthServices.logout();
        }
        return Promise.reject(error);
      },
    );
  }

  public async getInvites(
    queryParams?: Record<string, any>,
  ): Promise<IPagination> {
    const response: AxiosResponse<IPagination> = await this.api.get(
      '/invites',
      { params: queryParams },
    );
    return response.data;
  }

  public async updateInvite(
    id: string,
    updates: Partial<Invite>,
  ): Promise<Invite> {
    const response: AxiosResponse<Invite> = await this.api.patch(
      `/invites/${id}`,
      updates,
    );
    return response.data;
  }

  public async resendInvite(id: string): Promise<void> {
    await this.api.post(`/invites/${id}/resend-quote-request`);
  }

  public async deleteInvite(id: string): Promise<void> {
    await this.api.delete(`/invites/${id}`);
  }
}

const _inviteService = new InviteService(
  process.env.REACT_APP_SERVER_API_URL || 'http://localhost:3000',
);

export default _inviteService;
